import { ActionTypes as action } from "./action-types";
import { initialState } from './state';
import _ from "lodash";

const mutations = {
    [action.GET_DOCUMENT_LIST](state, data) {
        state.documentsList = data;
    },
    [action.GET_DOCUMENT_BY_ID](state, data) {
        state.documentDetails = data;
    },
    [action.GET_AGENDA_LIST_FOR_DOCUMENT](state, data) {
        state.agendaListForDocument = data;
    },
    [action.GET_MEETING_LIST_FOR_DOCUMENT](state, data) {
        state.meetingListForDocument = data;
    },
    [action.GET_MEETING_VIEWS](state, data) {
        state.documentViews = data;
    },
    [action.ADD_MEETING_VIEWS](state, documentId) {
        state.documentViews = {
            ...state.documentViews,
            ...{ [documentId]: true },
        }
    },
    [action.GET_LANDING_PAGE_DOCUMENTS_LIST](state, data) {
        state.landingPageDocumentsList = data;
    },
    [action.GET_LANDING_PAGE_DOCUMENT_BY_ID](state, data) {
        state.landingPageDocumentDetails = data;
    },
    [action.REMOVE_DOCUMENT_BY_ID](state, id) {
        const existIndex = state.landingPageDocumentsList.findIndex(item => item.id == id);
        if (existIndex !== -1) {
            state.landingPageDocumentsList.splice(existIndex , 1)
        }
    },
    [action.RESET_STATE](state) {
        Object.assign(state, initialState);
    },
};

export default mutations;
